import { Autocomplete, Box, Checkbox, Chip, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CountryList = (props) => {
  const [selectedValues, setSelectedValues] = useState(null);

  useEffect(() => {
    const creds = sessionStorage.getItem("storeCreds");
    const getCreds = JSON.parse(creds);
    if (sessionStorage.getItem("storeCreds")) {
      for (let i = 0; i < getCreds.length; i++) {
        if (getCreds[i].pspCode === props.value) {
          setSelectedValues(getCreds[i].chooseCountry);
        }
      }
    }
  }, []);
  useEffect(() => {
    props.setCountrySelected(selectedValues);
  }, [selectedValues]);

  return (
    <div>
      <Autocomplete
        multiple={false}
        options={props.options}
        getOptionLabel={(option) => option.name}
        renderOption={(props, option, { selected }) => (
          <li {...props}>{option.name}</li>
        )}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        value={selectedValues}
        onChange={(e, newValue) => setSelectedValues(newValue)}
        renderTags={() => null}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder="Select" />
        )}
        ListboxProps={{
          style: {
            maxHeight: '180px',
            overflowY: 'auto',
          },
        }}
      />
    </div>
  );
};

export default CountryList;
